// extracted by mini-css-extract-plugin
export default {"HeaderInput":"HeaderInput152Rk36nlHKa","HeaderInput_name-content":"HeaderInput_name-content2k07n738fxdF","excerpt":"excerpt3dxEsP9emqHf"};